import { useEffect, useState } from "react";
import { api, reloadConfig } from "../request/api";
import { DataGrid } from "devextreme-react";
import { Column } from "devextreme-react/data-grid";
import { EContractorType } from "../Types/EContractorType";
import { EkoBillingNavbar } from "../_components/EkoBillingNavbar/EkoBillingNavbar";
import DataSource from "devextreme/data/data_source";
import { CheckBox } from "devextreme-react/check-box";
import { EkoBillingHeader } from "../_components/EkoBillingHeader/EkoBillingHeader";
import { ContractorGridType } from "../Types/ContractorGridType";
import { Value } from "devextreme-react/range-selector";

const HomePage = () => {
  const [eContractor, setEContractor] = useState<EContractorType>();
  const [contractorGrid, setContractorGrid] = useState<ContractorGridType[]>();

  const getData = async () => {
    reloadConfig();
    const result = await api.get<EContractorType>(
      "EContractor/GetContractor"
    );
    setEContractor(result.data);

    const contractor = [
      { key: "Nazwa skrócona", value: result.data.contr_short },
      {
        key: "Pełna nazwa",
        value: result.data.addr_name + " " + result.data.addr_name2,
      },
      {
        key: "Faktura elektroniczna",
        value: result.data.cex_web_invoice_confirmed ? "tak" : "nie",
      },
      {
        key: "Ulica / numer domu",
        value: result.data.addr_street + " " + result.data.addr_house,
      },
      {
        key: "Numer mieszkania",
        value: result.data.addr_apartment,
      },
      { key: "Miejscowość", value: result.data.addr_city },
    ];
    setContractorGrid(contractor);
  };
  useEffect(() => {


    getData();
  }, []);

  return (
    <>
      <div className="mainTitle">Dane kontrahenta</div>
      <div className="row">
        <div className="col-md-12">
          <DataGrid
            id="gridContainer"
            className="noHeader"
            selection={{ mode: "single" }}
            dataSource={contractorGrid}
            showBorders={true}
            hoverStateEnabled={true}
            showColumnHeaders={false}
          >
            <Column dataField="key" caption="Klucz" />
            <Column dataField="value" caption="Wartość" />
          </DataGrid>
        </div>
      </div>
    </>
  );
};

export { HomePage };
